import { MessageCircle } from "lucide-react";
import { WHATSAPP_LINK } from "@/data/site";
import { trackEvent } from "@/lib/analytics";

const variants = {
    amber: "bg-amber text-navy-deep shadow-[0_10px_30px_rgba(245,166,35,0.35)] hover:bg-amber-dark",
    navy: "bg-navy text-white hover:bg-navy-hover",
    outline: "border border-navy/25 bg-white text-navy hover:border-navy hover:bg-navy hover:text-white",
    white: "bg-white text-navy hover:bg-steel-light",
};

export const WhatsAppButton = ({ label = "WhatsApp Quote", location = "generic", variant = "amber", className = "", href = WHATSAPP_LINK }) => (
    <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`whatsapp-cta-${location}`}
        onClick={() => trackEvent("whatsapp_click", { button_location: location })}
        className={`inline-flex items-center justify-center gap-2 rounded-md px-5 py-2.5 text-sm font-semibold transition-[background-color,color,border-color,transform] duration-300 hover:-translate-y-0.5 ${variants[variant]} ${className}`}
    >
        <MessageCircle className="h-4 w-4 shrink-0" strokeWidth={2.2} />
        {label}
    </a>
);
